import { useEffect, useState } from "react";
import CryptoES from "crypto-es";
import HomeView from "./view";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ReducersTypes } from "@/redux/reducers/Models";
import { setCustomer } from "@/redux/ducks/customer";
import { getFormattedValue } from "@/utils/functions";
import { useDebts } from "@/hooks/useDebts";
import { usePaidItems } from "@/hooks/usePaidItems";
import { useSingleFlag } from "@/hooks/useFlags";
import Loading from "@/atomic/atoms/Loading";

export default function Home() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isEnabled: isAutoPaymentEnabled, isLoading: isLoadingAutoPaymentFlag } = useSingleFlag('PD_COBRANCA_DIRETA');
  const { isEnabled: isNotificationsEnabled, isLoading: isLoadingNotificationsFlag } = useSingleFlag('PD_NOTIFICACOES');
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  const [isShowingMenu, setIsShowingMenu] = useState(false);
  const [isVisibleRecharge, setIsVisibleRecharge] = useState(false);
  const [isVisibleCardModal, setIsVisibleCardModal] = useState(true);
  const [activeTab, setActiveTab] = useState<"pendentes" | "pagos">("pendentes");

  const { isLoading: isLoadingDebts, debts, cart, onChange, getDebts } = useDebts();
  const { isLoading: isLoadingPaidItems, items: paidItems, refetch: refetchPaidItems } = usePaidItems();

  const toggleMenu = () => setIsShowingMenu((isShowingMenu) => !isShowingMenu);

  const goToVehicles = (plates: string | string[]) => {
    dispatch(setCustomer({ 
      selectedVehicles: Array.isArray(plates) ? plates : [plates] 
    }));
    navigate("/myvehicles");
  };

  const goToWallet = () => navigate("/wallet");

  const goToRecharge = () => navigate("/payment");

  const goToNewCard = () => navigate("/newcard");

  const goToBuy = () => navigate("/buy");

  const goToNotifications = () => navigate("/notifications");

  const showRecharge = async () => {
    const clientId = CryptoES.SHA512(customer?.client?.id!);
    const showWelcome = localStorage.getItem("showWelcome" + clientId);
    if (
      !showWelcome &&
      customer?.account?.balance === 0 &&
      !customer?.account?.card?.cardNumber
    ) {
      localStorage.setItem("showWelcome" + clientId, "true");
      setIsVisibleRecharge(true);
    }
  };

  const handleTabChange = (tab: "pendentes" | "pagos") => {    
    setActiveTab(tab);
    if (tab === "pagos") {
      if (isLoadingPaidItems) {
        return;
      }
      refetchPaidItems();
    } else {
      if (isLoadingDebts) {
        return;
      }
      getDebts();
    }
  };

  const handleDisablePendingAttemptPayment = () => {
    dispatch(setCustomer({ 
      disablePendingAttemptPaymentModal: true
    }));
  }

  useEffect(() => {
    showRecharge();
  }, [customer?.account]);

 

  const isLoadingFlags = isLoadingAutoPaymentFlag || isLoadingNotificationsFlag;

  return (
    <>
      {isLoadingFlags && <Loading />}
      <HomeView
        goToVehicles={goToVehicles}
        items={paidItems || []}
        isLoading={isLoadingDebts || isLoadingPaidItems}
        isShowingMenu={isShowingMenu}
        toggleMenu={toggleMenu}
        goToWallet={goToWallet}
        balance={getFormattedValue(customer?.account?.balance ?? 0)}
        plate={customer?.selectedVehicles?.length ? customer.selectedVehicles : customer?.vehicles?.[0]?.plate ?? ""}
        hasVehicles={customer?.vehicles!?.length > 1}
        isVisibleRecharge={
          isVisibleRecharge && !customer?.isLoading
        }
        goToRecharge={() => {
          setIsVisibleRecharge(false);
          goToRecharge();
        }}
        hasPendingAttemptPayment={!customer?.disablePendingAttemptPaymentModal && debts?.some(debt => debt.flRetentativa === 1)}
        handleDisablePendingAttemptPayment={handleDisablePendingAttemptPayment}
        setIsVisibleRecharge={setIsVisibleRecharge}
        goToBuy={goToBuy}
        isVisibleCardModal={isVisibleCardModal}
        setIsVisibleCardModal={setIsVisibleCardModal}
        debts={debts}
        cart={cart}
        onChangeDebts={onChange}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        goToNewCard={goToNewCard}
        isAutoPaymentEnabled={isAutoPaymentEnabled}
        goToNotifications={goToNotifications}
        isNotificationsEnabled={isNotificationsEnabled}
      />
    </>
  );
}
